module.exports = __webpack_public_path__ + "static/ariston-9389bbe7ed78f681862bf796ec4ae58d.png";